import{
    GET_STAFF_REQUEST,
    GET_STAFF_SUCCESS,
    GET_STAFF_FAIL,
    DELETE_STAFF_REQUEST,
    DELETE_STAFF_SUCCESS,
    DELETE_STAFF_FAIL,
    STAFF_DETAILS_REQUEST,
    STAFF_DETAILS_SUCCESS,
    STAFF_DETAILS_FAIL,
    CREATE_STAFF_REQUEST,
    CREATE_STAFF_SUCCESS,
    CREATE_STAFF_FAIL,
    EDIT_STAFF_REQUEST,
    EDIT_STAFF_SUCCESS,
    EDIT_STAFF_FAIL,
} from './actionTypes'

const INIT_STATE = {
    Staffs: [],
    Staff: {},
    isLoading: false,// This is now handled by the 
    error: null,
  };

const StaffReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_STAFF_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case GET_STAFF_SUCCESS:
            return {
                ...state,
                isLoading: false,
                Staffs: action.payload,
            };
        case GET_STAFF_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case DELETE_STAFF_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case DELETE_STAFF_SUCCESS:
            return {
                ...state,
                isLoading: false,
                Staffs: state.Staffs.filter(
                    Staff => Staff.email !== action.payload.email
                ),
               
            };
        case DELETE_STAFF_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case STAFF_DETAILS_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case STAFF_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                Staff: action.payload,
            };
        case STAFF_DETAILS_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CREATE_STAFF_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case CREATE_STAFF_SUCCESS:
            return {
                ...state,
                isLoading: false,
                Staffs: [...state.Staffs, action.payload],
            };
        case CREATE_STAFF_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case EDIT_STAFF_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case EDIT_STAFF_SUCCESS:
            return {
                ...state,
                isLoading: false,
                Staffs: state.Staffs.map(Staff => Staff.email === action.payload.email ? action.payload : Staff),
            };
        case EDIT_STAFF_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

export default StaffReducer;
